import { useState, useEffect } from "react";
import MainContainer from "../../components/app/maincontainer";
import { FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";
import Upload from "../../assets/icons/upload.svg";
import { MdDelete } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom";
import { NewInput, TextBox } from "../../components/inputs/main";
import PrimaryBtn, { MainBtn } from "../../components/app/buttons";
import DoneModal from "../../components/modals/donemodal";
import { combineArray } from "../../data/useExtractor";
import { toast } from "react-toastify";
import { IoIosAdd } from "react-icons/io";
import { apiCall } from "../../data/useFetcher";
import useErrorStore from "../../data/stores/errorStore";
import { AddUsersModal } from "../../components/modals/addtoolsmodal";
import RawSample from "../../assets/Tool Utility Sample 3.xlsx";
import RawSample2 from "../../assets/Tool Regulatory Sample.xlsx";
import { useRawdataStore } from "../../data/stores/loggerStore";
import { DataTableCenter } from ".";

const AddData = () => {
	const navigate = useNavigate(),
		[modal, setModal] = useState("");

	let [loading, setLoading] = useState(null),
		{ returnErrors } = useErrorStore(),
		location = useLocation()?.state,
		{ getDynamicLogger } = useRawdataStore();

	console.log({ location });

	let init2: {
			category?: string;
			data?: string;
			dataArr?: string[];
			description?: string;
		} = {
			category: "",
			data: "",
			dataArr: [],
			description: "",
		},
		init3: {
			category?: string;
			data?: {
				category?: string;
				data?: string;
				dataArr?: string[];
				description?: string;
			}[];
		} = { category: "", data: [init2] },
		utilityChecker = location?.item?.title?.toLowerCase()?.includes("utility");
	const [itemForm, setItemForm] = useState([init2]);
	const [itemForm2, setItemForm2] = useState([init3]);
	const handleInputChangeForMutipleItem = (
		e: React.ChangeEvent<HTMLInputElement> | any,
		index: number,
		field: string
	) => {
		const { value } = e?.target;
		let itemValue = value;

		setItemForm(prevRows => {
			const newRows = [...prevRows];
			newRows[index][field] = itemValue;
			return newRows;
		});
	};

	const handleInputChangeForMutipleItemMain = (
		e: React.ChangeEvent<HTMLInputElement> | any,
		index: number,
		field: string
	) => {
		const { value } = e?.target;
		let itemValue = value;

		setItemForm2(prevRows => {
			const newRows = [...prevRows];
			newRows[index][field] = itemValue;
			return newRows;
		});
	};

	const handleInputChangeForMutipleItem2 = (
		e: React.ChangeEvent<HTMLInputElement> | any,
		index: number,
		index2: number,
		field: string
	) => {
		const { value } = e?.target;

		setItemForm2(prevRows => {
			let newRows = [...prevRows];
			let clonedObject = { ...newRows[index].data[index2] };
			clonedObject = { ...clonedObject, [field]: value };
			// newRows[index] = {...newRows[index],data:clonedObject};
			let newArr = [
				...newRows[index].data?.map((it, i) =>
					i === index2 ? clonedObject : it
				),
			];

			newRows = [
				...newRows?.map((it, i) =>
					i === index
						? {
								...it,
								data: newArr,
						  }
						: it
				),
			];
			return newRows;
		});
	};

	const handleDeleteRowForMutipleItem = (index: number) => {
		setItemForm(prevRows => {
			const newRows = [...prevRows];
			newRows.splice(index, 1);
			return newRows;
		});
	};
	const handleDeleteRowForMutipleItem2 = (index: number) => {
		setItemForm2(prevRows => {
			const newRows = [...prevRows];
			newRows.splice(index, 1);
			return newRows;
		});
	};

	// Function to delete an item
	const deleteInnerData = (
		outerCategoryIndex: number,
		innerCategoryIndex: number
	) => {
		setItemForm2(prevRows => {
			const newRows = [...prevRows];
			newRows[outerCategoryIndex].data.splice(innerCategoryIndex, 1);
			return newRows;
		});
	};

	const handleInputKeyPress = (
		e: React.KeyboardEvent<HTMLInputElement>,
		index: number,
		field: string
	) => {
		console.log({ e });

		setItemForm(prevRows => {
			const newRows = [...prevRows];
			// console.log({ e: e.key });
			let emailInput = newRows[index].data;
			if (e.key === "Enter" && emailInput.trim() !== "") {
				e?.preventDefault(); // This prevents the default form submission behavior
				newRows[index][field] = Array.isArray(newRows[index][field])
					? [...newRows[index][field], emailInput.trim()]
					: [emailInput.trim()];
				newRows[index].data = "";
			}
			return newRows;
		});
	};

	const handleInputKeyPressNew = (
		e: React.KeyboardEvent<HTMLInputElement>,
		index: number,
		index2: number,
		field: string
	) => {
		console.log({ e });

		setItemForm2(prevRows => {
			let newRows = [...prevRows];
			// console.log({ e: e.key });
			let clonedObject = { ...newRows[index].data[index2] };
			let emailInput = clonedObject.data;
			if (e.key === "Enter" && emailInput.trim() !== "") {
				e?.preventDefault(); // This prevents the default form submission behavior
				clonedObject[field] = Array.isArray(clonedObject[field])
					? [...clonedObject[field], emailInput.trim()]
					: [emailInput.trim()];
				clonedObject.data = "";
				// newRows[index] = {...newRows[index],data:clonedObject};
				let newArr = [
					...newRows[index].data?.map((it, i) =>
						i === index2 ? clonedObject : it
					),
				];

				newRows = [
					...newRows?.map((it, i) =>
						i === index
							? {
									...it,
									data: newArr,
							  }
							: it
					),
				];
			}
			return newRows;
		});
	};

	const addRowForMutipleItem = () => {
		const newRow = init2;
		setItemForm([...itemForm, newRow]);
	};
	const addRowForMutipleItem2 = () => {
		setItemForm2(prev => {
			return [...prev, init3];
		});
	};
	const addRowForMutipleItem3 = (index: number) => {
		setItemForm2(prev => {
			let newPrev = [...prev];

			newPrev[index].data?.push(init2);

			return newPrev;
		});
	};

	let [pres, setPres] = useState<any>(null);

	const [bulkUpload, setBulkUpload] = useState(false);
	const toggleUploadModal = () => {
		setPres(null);
		setBulkUpload(false);
	};

	const onSubmit2 = async () => {
		console.log({ pres });
		if (pres?.length === 0) return toast.info("Rawdata' details required");

		if (!utilityChecker) {
			try {
				let newItemForm = combineArray(pres),
					newerItemForm = [];
				// console.log({ newItemForm });
				for (let n = 0; n < newItemForm?.length; n++) {
					let element = newItemForm?.[n];
					for (let c = 0; c < element?.length; c++) {
						let elementC = element?.[c],
							findIn = newerItemForm?.find(
								ir => ir?.category === elementC?.category
							);
						if (findIn) {
							// console.log({ ele: elementC?.data, fiIn: findIn?.data });
							let newD = [];
							if (findIn?.data && Array.isArray(findIn?.data))
								newD = [...newD, ...findIn?.data];
							if (elementC?.data && Array.isArray(elementC?.data))
								newD = [...newD, ...elementC?.data];
							findIn.data = newD;
							newerItemForm = newerItemForm?.map(ix =>
								ix?.category === findIn?.category ? findIn : ix
							);
						} else {
							newerItemForm?.push(elementC);
						}
					}
				}
				console.log({ newItemForm, newerItemForm });
				let newItem = [];
				for (let n = 0; n < newerItemForm?.length; n++) {
					const element = newerItemForm?.[n];
					newItem = [
						...newItem,
						{
							...element,
							category: element?.category,
							dataArr: element?.data,
							data: "",
							description: element?.description,
						},
					];
				}
				setItemForm(
					itemForm?.[0]?.category ? [...itemForm, ...newItem] : newItem
				);

				toggleUploadModal();
			} catch (err) {
				if (err) console.log({ error: err.response?.data, err });
			}
		} else {
			try {
				let newItem = [];
				for (let n = 0; n < pres?.length; n++) {
					const element = pres?.[n];
					newItem = [
						...newItem,
						{
							...element,
							category: element?.category,
							data: element?.data?.map((it: any) => {
								return {
									category: it?.category,
									dataArr: it?.data,
									data: "",
									description: it?.description,
								};
							}),
						},
					];
				}
				setItemForm2(
					itemForm2?.[0]?.category ? [...itemForm, ...newItem] : newItem
				);

				toggleUploadModal();
			} catch (err) {
				if (err) console.log({ error: err.response?.data, err });
			}
		}
	};

	useEffect(() => {
		if (pres) onSubmit2();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pres]);

	useEffect(() => {
		if (!location) navigate(-1);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	// console.log({ itemForm });

	const onSubmit = async (event?: React.FormEvent<HTMLFormElement>) => {
		event?.preventDefault();
		let thisMainData: any[] = itemForm,
			finalMainData: any[] = [];
		if (utilityChecker) thisMainData = itemForm2;
		if (thisMainData?.length === 0) return toast.info("Data set required");
		if (thisMainData?.length === 1)
			if (
				!thisMainData?.[0]?.category ||
				thisMainData?.[0]?.dataArr?.length === 0
			)
				return toast.info("Data set required");

		if (!utilityChecker) finalMainData = itemForm;
		if (utilityChecker) {
			for (let i = 0; i < itemForm2.length; i++) {
				const element = itemForm2[i];

				finalMainData = [
					...finalMainData,
					...element?.data?.map(it => {
						return {
							category: it?.category,
							upperCategory: element?.category,
							dataArr: it?.dataArr,
							description: it?.description,
						};
					}),
				];
			}
		}

		setLoading(true);

		let { response, errArr, errMsg } = await apiCall({
			type: "post",
			url: `/api/v1/rawdata/manage-kpis`,
			data: {
				rawdata: finalMainData?.map(item => {
					return {
						...item,
						data: item?.dataArr?.map(it => {
							return {
								title: it?.trim(),
							};
						}),
					};
				}),
				category: location?.category,
				data: location?.item?.title,
			},
		});
		// console.log({ response, errArr, errMsg });
		if (errArr) {
			setLoading(false);
			return returnErrors(errArr);
		}
		if (errMsg) {
			setLoading(false);
			return toast.error(errMsg);
		}
		setLoading(false);
		if (response) {
			apiCall({
				type: "get",
				url: `/api/v1/rawdata/manage-kpis?category=${location?.category}&data=${location?.item?.title}`,
				getter: (d: any) => getDynamicLogger(d, "kpidata"),
			});
			setModal("done");
			setItemForm([init2]);
			setItemForm2([init3]);
			return;
		}
		setLoading(false);
		setLoading(false);
	};

	return (
		<div>
			<MainContainer>
				<div className="mt-8 flex justify-between items-center">
					<div className="flex gap-2">
						<FaChevronLeft
							color="#334155"
							onClick={() => navigate(-1)}
							className="cursor-pointer mt-1"
						/>
						<div>
							<h1 className="text-xl font-semibold text-da-blue-600 inter">
								Add {location?.category} KPIs
							</h1>
							<div className="flex gap-2 items-center">
								<span className="text-base font-normal text-[#334155]">
									Data List
								</span>
								<FaChevronRight color="#334155" size={10} />
								<span className="text-base font-normal text-[#334155]">
									Add {location?.item?.title} KPIs
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="mt-12 bg-white min-h-screen w-full p-8">
					<div
						style={{
							borderBottom: "1px solid #E2E8F0",
						}}
						className="h-full w-full pb-3 flex justify-between">
						<h4 className="text-xl font-semibold inter text-da-blue-600">
							{location?.item?.title} KPI Data
						</h4>
						<PrimaryBtn
							color={"#3787FF"}
							onClick={() => setBulkUpload(!bulkUpload)}
							icon={Upload}
							text={"Bulk Upload"}
							bg={"transparent"}
							className="border border-da-blue-100"
						/>
					</div>
					<form className="mt-6" onSubmit={onSubmit}>
						{utilityChecker
							? itemForm2?.map((item, index) => (
									<>
										<div className="relative grid md:grid-cols-3  w-11/12 gap-5">
											<div className="col-span-3">
												<NewInput
													onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
														handleInputChangeForMutipleItemMain(
															e,
															index,
															"category"
														)
													}
													value={item?.category}
													label={"KPI Main Category"}
													placeholder={"KPI dataset"}
												/>
											</div>
											<div className="col-span-3 mb-4">
												{item?.data?.map((inner, innerIndex) => (
													<div
														className="relative grid md:grid-cols-3  w-10/12 gap-5"
														key={innerIndex}>
														<div>
															<NewInput
																onChange={(
																	e: React.ChangeEvent<HTMLInputElement>
																) =>
																	handleInputChangeForMutipleItem2(
																		e,
																		index,
																		innerIndex,
																		"category"
																	)
																}
																value={inner?.category}
																label={"KPI Category"}
																placeholder={"KPI dataset"}
															/>
														</div>
														<div className="col-span-2">
															<div>
																<label className="text-[#334155] font-medium text-sm inter">
																	KPI data*
																</label>
																<div className="">
																	{inner?.dataArr?.length > 0 && (
																		<div className="flex items-center gap-2 overflow-x-auto py-2 px-3">
																			{inner?.dataArr?.map((it, x) => (
																				<span
																					key={x}
																					className="text-xs border border-black rounded-full px-3 py-1 flex items-center justify-between gap-3 w-auto whitespace-nowrap">
																					{it}{" "}
																					<FaTimes
																						className="cursor-pointer"
																						onClick={() => {
																							setItemForm2(prevRows => {
																								let newRows = [...prevRows];
																								let clonedObject = {
																									...newRows[index].data[
																										innerIndex
																									],
																								};
																								let newDataArr =
																									clonedObject?.dataArr?.filter(
																										(j, k) => k !== x
																									);
																								clonedObject = {
																									...clonedObject,
																									dataArr: newDataArr,
																								};
																								// newRows[index] = {...newRows[index],data:clonedObject};
																								let newArr = [
																									...newRows[index].data?.map(
																										(it, i) =>
																											i === innerIndex
																												? clonedObject
																												: it
																									),
																								];
																								newRows = [
																									...newRows?.map((it, i) =>
																										i === index
																											? {
																													...it,
																													data: newArr,
																											  }
																											: it
																									),
																								];
																								return newRows;
																							});
																						}}
																					/>
																				</span>
																			))}
																		</div>
																	)}
																	<NewInput
																		onKeyUp={(
																			e: React.KeyboardEvent<HTMLInputElement>
																		) =>
																			handleInputKeyPressNew(
																				e,
																				index,
																				innerIndex,
																				"dataArr"
																			)
																		}
																		placeholder="Press Enter to input a new KPI data"
																		onChange={(
																			e: React.ChangeEvent<HTMLInputElement>
																		) =>
																			handleInputChangeForMutipleItem2(
																				e,
																				index,
																				innerIndex,
																				"data"
																			)
																		}
																		value={inner?.data}
																		label={""}
																	/>
																</div>
															</div>
														</div>
														<div
															onClick={() => deleteInnerData(index, innerIndex)}
															className="md:absolute self-center -right-20 cursor-pointer">
															<p className="text-sm text-red-600 flex items-center md:mt-2 gap-2">
																<span>
																	<MdDelete />
																</span>
																Remove
															</p>
														</div>
														<div className=" col-span-3">
															<TextBox
																placeholder="KPI Description"
																value={inner?.description}
																label={"KPI Description"}
																onChange3={(
																	e: React.ChangeEvent<HTMLTextAreaElement>
																) =>
																	handleInputChangeForMutipleItem2(
																		e,
																		index,
																		innerIndex,
																		"description"
																	)
																}
															/>
														</div>
													</div>
												))}
												<p
													onClick={() => addRowForMutipleItem3(index)}
													className="flex items-center gap-2 text-bluerolodex f-medium my-3 cursor-pointer pl-10">
													<span>
														<IoIosAdd />
													</span>
													Add Inner KPI
												</p>
											</div>
											<div
												onClick={() => handleDeleteRowForMutipleItem2(index)}
												className="md:absolute self-center -right-20 cursor-pointer">
												<p className="text-sm text-red-600 flex items-center md:mt-2 gap-2">
													<span>
														<MdDelete />
													</span>
													Remove
												</p>
											</div>
										</div>
									</>
							  ))
							: itemForm?.map((item, index) => (
									<>
										<div className="relative grid md:grid-cols-3  w-4/5 gap-5">
											<div>
												<NewInput
													onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
														handleInputChangeForMutipleItem(
															e,
															index,
															"category"
														)
													}
													value={item?.category}
													label={"KPI Category"}
													placeholder={"KPI dataset"}
												/>
											</div>
											<div className="col-span-2">
												<div>
													<label className="text-[#334155] font-medium text-sm inter">
														KPI data*
													</label>
													<div className="">
														{item?.dataArr?.length > 0 && (
															<div className="flex items-center gap-2 overflow-x-auto py-2 px-3">
																{item?.dataArr?.map((it, x) => (
																	<span
																		key={x}
																		className="text-xs border border-black rounded-full px-3 py-1 flex items-center justify-between gap-3 w-auto whitespace-nowrap">
																		{it}{" "}
																		<FaTimes
																			className="cursor-pointer"
																			onClick={() => {
																				let newArr = item?.dataArr?.filter(
																					(j, k) => k !== x
																				);
																				let newItem = {
																					...item,
																					dataArr: newArr,
																				};
																				let newFinal = itemForm?.map((it, d) =>
																					d === index ? newItem : it
																				);
																				setItemForm(newFinal);
																				// setItemForm(prevRows => {
																				// 	const newRows = [...prevRows];
																				// 	newRows[index].dataArr?.splice(x, 1);
																				// 	return newRows;
																				// });
																			}}
																		/>
																	</span>
																))}
															</div>
														)}
														<NewInput
															onKeyUp={(
																e: React.KeyboardEvent<HTMLInputElement>
															) => handleInputKeyPress(e, index, "dataArr")}
															placeholder="Press Enter to input a new KPI data"
															onChange={(
																e: React.ChangeEvent<HTMLInputElement>
															) =>
																handleInputChangeForMutipleItem(
																	e,
																	index,
																	"data"
																)
															}
															value={item?.data}
															label={""}
														/>
													</div>
												</div>
											</div>
											<div
												onClick={() => handleDeleteRowForMutipleItem(index)}
												className="md:absolute self-center -right-20 cursor-pointer">
												<p className="text-sm text-red-600 flex items-center md:mt-2 gap-2">
													<span>
														<MdDelete />
													</span>
													Remove
												</p>
											</div>
											<div className=" col-span-3">
												<TextBox
													placeholder="KPI Description"
													onChange3={(
														e: React.ChangeEvent<HTMLTextAreaElement>
													) =>
														handleInputChangeForMutipleItem(
															e,
															index,
															"description"
														)
													}
													value={item?.description}
													label={"KPI Description"}
												/>
											</div>
										</div>
									</>
							  ))}
						<p
							onClick={
								utilityChecker ? addRowForMutipleItem2 : addRowForMutipleItem
							}
							className="flex items-center gap-2 text-bluerolodex f-medium my-3 cursor-pointer">
							<span>
								<IoIosAdd />
							</span>
							Add KPI
						</p>
						<div className="flex mt-9 gap-5">
							<MainBtn
								onClick={() => navigate(-1)}
								className="border border-[#FECACA]"
								text={"Discard"}
								bg={"transparent"}
								color={"#EF4444"}
								type="button"
								disabled={loading}
							/>
							<MainBtn
								text={"Continue"}
								bg={"#3787FF"}
								color={"white"}
								loading={loading}
								type="button"
								onClick={() => onSubmit()}
							/>
						</div>
					</form>
					<ApplicationLevel />
				</div>
				{modal === "done" && (
					<DoneModal
						page={"Data"}
						handleClose={() => setModal("")}
						path={"/data"}
						close={() => {
							setModal("");
							setItemForm([init2]);
						}}
					/>
				)}
				{bulkUpload && (
					<AddUsersModal
						handleClose={toggleUploadModal}
						title={"Upload new data list"}
						subtitle="Add new data"
						handleImport={pres2 => {
							setPres(pres2);
						}}
						sample={
							utilityChecker ? RawSample || RawSample2 : RawSample2 || RawSample
						}
						processInner={utilityChecker}
					/>
				)}
			</MainContainer>
		</div>
	);
};

export default AddData;

const ApplicationLevel = () => {
	const [tab, setTab] = useState("all KPIs"),
		tabs = ["all KPIs", "Newly uploaded KPIs"],
		location = useLocation()?.state;

	let { getDynamicLogger }: any = useRawdataStore();

	useEffect(() => {
		apiCall({
			type: "get",
			url: `/api/v1/rawdata/manage-kpis?category=${location?.category}&data=${
				location?.item?.title
			}${tab !== tabs?.[0] ? `&streamline=week` : ""}`,
			getter: (d: any) =>
				getDynamicLogger(d, tab !== tabs?.[0] ? "kpirecent" : "kpidata"),
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tab]);

	return (
		<>
			<div className="mt-8 bg-white rounded-lg p-6">
				<div className="h-16 border-b border-b-[#E3E3E3] flex gap-4">
					{tabs?.map((t, i) => (
						<button
							key={i}
							onClick={() => setTab(t)}
							className={`h-full capitalize px-1 text-base ${
								tab === t
									? "font-medium border-b-4 text-[#111014] border-b-[#2658AB]"
									: "font-normal border-b-none text-[#878789]"
							}`}>
							{t}
						</button>
					))}
				</div>
				<MainSection tab={tab} tabs={tabs} />
			</div>
		</>
	);
};
const MainSection = ({ tab, tabs }) => {
	let [datum, setDatum] = useState<any>({ docs: [] }),
		{ mainSearch, isFound, kpidata, kpirecent, getDynamicLogger }: any =
			useRawdataStore(),
		[loading, setLoading] = useState<string | boolean>(false),
		location = useLocation()?.state;

	useEffect(() => {
		if (isFound) setDatum(mainSearch);
		else setDatum(tab === tabs?.[1] ? kpirecent : kpidata);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [kpidata, isFound, mainSearch, tab, kpirecent]);

	const handleLoadMore = async () => {
		setLoading("loadmore");
		await apiCall({
			type: "get",
			url: `/api/v1/rawdata/manage-kpis?category=${location?.category}&data=${
				location?.item?.title
			}&limit=${datum?.limit * datum?.nextPage}${
				tab !== tabs?.[0] ? `&streamline=week` : ""
			}`,
			getter: (d: any) =>
				getDynamicLogger(d, tab !== tabs?.[0] ? "kpirecent" : "kpidata"),
		});
		setLoading(false);
	};

	const [itemOffset, setItemOffset] = useState(0);
	let [range] = useState(10);
	const endOffset = itemOffset + range;

	// if (!datum && !data) return <PageLoader />;
	if (!datum) return;

	const currentItems = datum?.docs?.slice(itemOffset, endOffset);
	const pageCount = Math.ceil(datum?.docs?.length / range);

	const handlePageClick = (event: any) => {
		const newOffset = (event.selected * range) % datum?.docs?.length;
		setItemOffset(newOffset);
	};

	return (
		<DataTableCenter
			currentItems={currentItems}
			pageCount={pageCount}
			datum={datum}
			handleLoadMore={handleLoadMore}
			loading={loading}
			handlePageClick={handlePageClick}
			usecase="application-level"
			setDatum={setDatum}
		/>
	);
};